import React, { Component } from "react";
import { connect } from "react-redux";
import { Get, Put, GetFile, Post } from "utils/axios";
import { requestError, requestSuccess } from "utils/requestHandler";
import _ from "lodash";

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      showErrorMessage: false,
      showCreateCompanyModal: false,
      advertiserList: [],
      advertiserPages: 1,
      advertiserCount: 0,
      selectionCreate: [],
      showFilterModal: false,
      showEditModal: false,

      natureList: [],

      filterQuery: null,
    };

    onChangeHOC = (key, val) => this.setState({ [key]: val });

    load = (param) => this.setState({ loading: param });

    getAdvertiser = (queryString = "") => {
      Get(
        "/reports/advertiser-reports?limit=10" + queryString,
        this.getAdvertiserSuccess,
        this.getAdvertiserError,
        this.load
      );
    };
    getAdvertiserSuccess = (payload) => {
      this.setState({
        advertiserList: payload.data.rows,
        advertiserCount: payload.data.count,
      });
    };
    getAdvertiserError = (error) => requestError(error);

    getNature = () => {
      this.setState({ loading: true });
      Get(
        // "/jobads/specializations",
        "/industries",
        this.getNatureSuccess,
        this.getNatureError,
        this.load
      );
    };
    getNatureSuccess = (payload) => {
      this.setState({
        natureList: payload.data,
      });
    };
    getNatureError = (error) => requestError(error);

    exportReport = () => {
        Get(
            `/report-generate/xlsx/manage-advertisers-reports?${this.state.filterQuery?.slice(1) || ""}`,
            this.exportReportSuccess,
            this.exportReportError,
            this.load
        );
    };
    exportReportSuccess = (payload) => {
        requestSuccess(payload.message);
        window.open(payload.ossUrl, "_blank");
    };
    exportReportError = (error) => requestError(error);

      

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          showCreateCompanyModal={this.state.showCreateCompanyModal}
          getAdvertiser={this.getAdvertiser}
          updateAdvertiser={this.updateAdvertiser}
          createSample={this.createSample}
          onChangeHOC={this.onChangeHOC}
          advertiserList={this.state.advertiserList}
          advertiserPages={this.state.advertiserPages}
          advertiserCount={this.state.advertiserCount}
          showFilterModal={this.state.showFilterModal}
          showEditModal={this.state.showEditModal}
          natureList={this.state.natureList}
          getNature={this.getNature}

          getSelectedCompany={this.getSelectedCompany}
          getCompanyImage={this.getCompanyImage}

          exportReport={this.exportReport}
        />
      );
    };
  }
  const mapStateToProps = (state) => ({ data: state });
  return connect(mapStateToProps)(WithHOC);
};
export default HOC;
